module.exports = __webpack_public_path__ + "static/media/lagertha.bf29e510.jpg";